(() => {
 function init(root = document) {
  root.querySelectorAll('[data-avgar-hero-video]').forEach(video => {
   if (video.dataset.initialized) return;
   video.dataset.initialized = 'true';
   const button = video.parentElement.querySelector('[data-avgar-video-toggle]');
   const mobile = matchMedia('(max-width:749px)');
   const reduced = matchMedia('(prefers-reduced-motion:reduce)');
   const sync = () => {if (!button) return; button.textContent = video.paused ? 'Play video' : 'Pause video';};
   const play = () => video.play().catch(sync);
   const source = () => {
    video.muted = true;
    video.src = mobile.matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
    video.load();
    if (!reduced.matches) play();
   };
   if (button) button.hidden = false;
   button?.addEventListener('click', () => {if (video.paused) play(); else video.pause();});
   video.addEventListener('play',sync); video.addEventListener('pause',sync);
   video.addEventListener('error',() => {if (button) button.hidden = true;});
   mobile.addEventListener('change',source);
   reduced.addEventListener('change',() => {if(reduced.matches)video.pause();});
   source(); sync();
  });
 }
 init(); document.addEventListener('shopify:section:load',e => init(e.target));
})();
